import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit
} from '@angular/core';
import { locale } from 'app/charts-dashboard/components/dialogs/compare-date-dialog/compare-date-dialog.locale';
import {
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  ChartFilterPatternNameEnum,
  IChartFilter,
  IChartFilterPattern,
  ISelectedFilters,
  Pattern,
  ICompareDateDialog,
  SymbolDialogActionEnum,
  ICompareDialogOutput
} from 'app/charts-dashboard/interfaces';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { TuiDialogContext } from '@taiga-ui/core';

@Component({
  selector: 'iv-live-compare-date-dialog',
  templateUrl: './compare-date-dialog.component.html',
  styleUrls: ['./compare-date-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompareDateDialogComponent implements OnInit {

  constructor(
    @Inject(POLYMORPHEUS_CONTEXT) private readonly context: TuiDialogContext<ICompareDialogOutput, ICompareDateDialog>
  ) {
  }

  public get isCompare(): boolean {
    return this.context.data.action === SymbolDialogActionEnum.COMPARE_SERIES;
  }

  public get mainSeriesSelectedFilters(): {
    selected: ISelectedFilters,
    filters: IChartFilter[]
  } {
    return {selected: this.context.data.selectedFilters, filters: this.context.data.filters};
  }

  public filterPattern: { [patternId: string]: IChartFilterPattern<Pattern>[] } = {};
  public filterTypes = ChartFilterPatternNameEnum;
  public locale = locale;
  public isFullScreenOpened = !!document.fullscreenElement;

  public form = new FormGroup({});

  public ngOnInit(): void {
    if (this.mainSeriesSelectedFilters) {
      this.changeFiltersForm();
    }
  }

  public getFilterName(filterKey: string): string {
    return this.mainSeriesSelectedFilters.filters.find((chartFilter: IChartFilter) => chartFilter.parameterId === filterKey).name;
  }

  public submit(): void {
    this.context.completeWith({
      action: this.context.data.action,
      selectedFilters: this.form.value,
      stock: null,
      seriesId: this.context.data.seriesId,
      parentCardId: this.context.data.parentCardId
    });
  }

  private changeFiltersForm(): void {
    this.mainSeriesSelectedFilters.filters.forEach((chartFilter: IChartFilter) => {
      if (
        chartFilter.parameterId === ChartFilterPatternNameEnum.STOCK_ID ||
        chartFilter.parameterId === ChartFilterPatternNameEnum.REALTIME
      ) return;

      this.filterPattern[chartFilter.parameterId] = chartFilter.pattern;
      this.form.addControl(chartFilter.parameterId, new FormControl(this.mainSeriesSelectedFilters.selected[chartFilter.parameterId], Validators.required));
    });
  }
}
